module.exports = __webpack_public_path__ + "static/media/dataSave.8e8933ff.mp3";